<template>
  <div class="miya-user-info" :class="showUserInfo ? 'show' : ''">
    <div class="phoneBg" @click="showUserInfo = false">
      <p class="clickClose">{{ $t("login.close1") }}</p>
    </div>
    <div
      class="phoneUserBtn"
      v-if="pageWidth < 800"
      @click="showUserInfo = !showUserInfo"
    >
      <img
        class="avatar"
        :src="require(`@assets/images/avatar/${this.avatarId}.svg`)"
      />
      <p class="balance-box">
        <span class="value">{{ usdtSurplus }} USDT</span>
        <span class="btn"
          ><span>{{ $t("login.recharge1") }}</span
          ><i class="el-icon-arrow-right"></i
        ></span>
      </p>
    </div>
    <div class="user-header">
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('menu.backHome')"
        placement="bottom"
      >
        <div class="btnBack" @click.stop="$router.push('/home')"></div>
      </el-tooltip>
      <miya-lang></miya-lang>
    </div>
    <div class="info-container">
      <div class="user-avatar">
        <img
          class="avatar"
          :src="require(`@assets/images/avatar/${this.avatarId}.svg`)"
        />
      </div>
      <p class="username">{{ account }}</p>
      <p class="secret">secret：{{ secret }}</p>
      <div class="editBtn">
        <el-button type="info" size="mini" @click="clickEditPassword()">{{
          $t("login.editPassword")
        }}</el-button
        ><br /><br />
        <el-button
          type="info"
          v-if="
            user.account == 'testuser' ||
              user.account == 'chenninglu123@gmail.com'
          "
          size="mini"
          @click="clickShowISPAnaly()"
          >ISP统计</el-button
        ><br /><br />
        <el-button
          type="info"
          v-if="
            user.account == 'testuser' ||
              user.account == 'chenninglu123@gmail.com'
          "
          size="mini"
          @click="getDataList()"
          >修改ISP</el-button
        >
      </div>
      <div class="adsInfo">
        <img
        @click="clickToOpen"
          src="@assets/images/dynamic/ads.jpg"
        />
      </div>
      <p class="balance-box">
        <label>{{ $t("login.balance") }}</label
        ><span class="value-box"
          ><span class="value">{{ usdtSurplus }}</span
          ><span class="unit">USDT</span></span
        >
      </p>
      <miya-btn
        ref="miyaBtn"
        @click="clickRecharge()"
        :title="$t('login.recharge')"
        class="rechargeBtn"
      ></miya-btn>
      <el-button
        size="medium"
        type="info"
        class="logout miyaBtnInfo"
        plain
        @click="clickLogout()"
        >{{ $t("login.logout") }}</el-button
      >
    </div>
    <el-dialog
      :title="$t('login.title3')"
      :visible.sync="dialogResetPassword"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="pageWidth < 800 ? '94%' : '524px'"
    >
      <reset-password ref="reset" @success="resetSuccess()">
        <template slot="btnCancel">
          <div class="cancelReset" @click.stop="dialogResetPassword = false">
            {{ $t("pTraffic.payCancel") }}
          </div>
        </template>
      </reset-password>
    </el-dialog>
    <el-dialog
      class="dialogRecharge"
      :title="$t('login.recharge')"
      :modal-append-to-body="false"
      :visible.sync="dialogRecharge"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="pageWidth < 800 ? '94%' : '524px'"
    >
      <div class="recharge-box">
        <p class="cardTip">{{ $t("login.rechargeTip") }}</p>
        <div class="row">
          <p class="titleName">{{ $t("login.rechargeType") }}</p>
          <p class="value">TRC20</p>
        </div>
        <div class="row">
          <p class="titleName">{{ $t("login.rechargeCode") }}</p>
          <p class="value">TUPXLaUS1eb1sgPBqBbNuQEsEzVoDa1RWj</p>
        </div>
        <div class="row">
          <p class="titleName"></p>
          <div class="qrcode">
            <img class="qrimg" src="@assets/images/login/qr-usdt.png" />
            <p class="codeName">{{ $t("login.qrCodeText") }}</p>
          </div>
        </div>
        <p class="titleName hashTitle">{{ $t("login.hash") }}</p>
        <el-input
          class="inputHash"
          size="medium"
          clearable
          :placeholder="$t('login.rechargeInput')"
          v-model="hash"
        ></el-input>
        <p class="inputTip">{{ $t("login.hashTip") }}</p>
        <el-button
          class="btn-ok"
          type="info"
          size="medium"
          @click.stop="clickSubmit()"
          >{{ $t("login.commit") }}</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogUpdateIsp"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display: flex">
        <div style="width:30%;">
          <el-input
            size="medium"
            v-model="searchUser"
            placeholder="输入用户邮箱查询"
            clearable
            @change="getDataList()"
            ><i slot="suffix" class="el-input__icon el-icon-search"></i
          ></el-input>
        </div>

        <div style="width:30%;">
          <el-input
            size="medium"
            v-model="searchText"
            placeholder="输入IP或者国家"
            clearable
            @change="getDataList()"
            ><i slot="suffix" class="el-input__icon el-icon-search"></i
          ></el-input>
        </div>
      </div>
      <el-table
        row-key="id"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        :highlight-selection-row="true"
        v-loading="tableLoading"
        style="width: 100%;"
      >
        <el-table-column
          prop="type"
          :label="$t('dashboard.typeString')"
          min-width="70"
        >
          <template slot-scope="scope">
            <!-- <p class="type-name">{{$t('home.pTitle3')}}</p> -->
            <div class="value-box">
              <!-- <label>{{$t('home.pSubtitile4')}}</label> -->
              <label v-if="scope.row.mealType === 3" class="type"
                >{{ $t("pAgent.type1") }}-{{ scope.row.country }}</label
              >
              <label v-if="scope.row.mealType === 4" class="type"
                >{{ $t("pAgent.type2") }}-{{ scope.row.country }}</label
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="proxy" :label="$t('pAgent.t1')" min-width="110">
          <template slot-scope="scope">
            <div class="s5TextBox">
              <span>{{ scope.row.origins5Proxy }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="$t('pAgent.operation')" width="190">
          <template slot-scope="scope">
            <el-button
              type="info"
              style="width:80px;"
              size="medium"
              @click="clickChange(scope.row)"
              >更换代理</el-button
            >
          </template>
        </el-table-column>
        <div slot="empty" class="table_nodata">
          <img
            v-if="!tableLoading"
            class="nodata"
            src="@/assets/images/home/noData.png"
            height="240"
            alt=""
          />
          <p v-if="!tableLoading" class="nodataText">
            {{ $t("home.noData") }}
          </p>
        </div>
      </el-table>

      <el-pagination
        size="medium"
        layout="total, sizes, prev, pager, next"
        :page-sizes="[8, 20, 30, 50]"
        :page-size="pageSize"
        :current-page="page"
        :pager-count="5"
        :total="total"
        @size-change="changeDataSize"
        @current-change="changePage"
      ></el-pagination>
    </el-dialog>

    <el-dialog
      :visible.sync="centerDialogVisible"
      title="ISP修改"
      width="500"
      center
    >
      <el-input
        v-model="changeIp"
        style="width: 240px"
        placeholder="输入ip，如127.0.0.1"
      />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="confirmChange">
            Confirm
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      :visible.sync="ispAnalyDialogVisible"
      title="ISP统计"
      width="500"
      center
    >
      <table style="margin:auto">
        <tr>
          <th>网段</th>
          <th>出售次数</th>
        </tr>
        <tr v-for="(item, idx) in ispAnalyData">
          <td>{{ item.key }}</td>
          <td>{{ item.count }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>
import miyaLang from "@components/lang.vue";
import { mapGetters, mapActions } from "vuex";
import miyaBtn from "@components/miyaBtn.vue";
import { logout } from "@assets/js/http.js";
import resetPassword from "@views/login/resetPasswordComponent.vue";
export default {
  data() {
    return {
      dialogResetPassword: false,
      dialogRecharge: false,
      dialogUpdateIsp: false,
      hash: "",
      country: "",
      searchUser: "",
      searchText: "",
      priceTop: 0,
      total: 0,
      page: 1,
      pageSize: 8,
      changeIp: "",
      ispAnalyData: [],
      tableData: [],
      tableLoading: false,
      ispAnalyDialogVisible: false, //isp统计
      centerDialogVisible: false,
      showUserInfo: false,
      currentChangeRow: undefined,
    };
  },
  computed: {
    usdtSurplus() {
      return this.user.usdtSurplus || "0";
    },
    account() {
      return this.user.account || "";
    },
    secret() {
      return this.user.secret || "";
    },
    avatarId() {
      if (this.user && this.user.id) {
        return (
          (Number(
            this.user.id.substring(this.user.id.length - 3, this.user.id.length)
          ) %
            13) +
          1
        );
      }
      return "0";
    },
    ...mapGetters(["user"]),
  },
  mounted() {
    this.pageWidth >= 800 ? (this.showUserInfo = true) : "";
    this.getData();
  },
  methods: {
    clickToOpen() {
      window.open('https://share.adspower.net/yi7xzTWBIV6czMU', '_blank');
    },
    clickShowISPAnaly() {
      this.ispAnalyDialogVisible = true;
      this.$get(`/UserIsp/IspAnlaysForAdmin`).then((res) => {
        if (res.code === 200) {
          this.ispAnalyData = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    confirmChange() {
      this.$post(`/UserIsp/UpdateIsp`, {
        id: this.currentChangeRow.id,
        proxy: this.changeIp,
      }).then((res) => {
        if (res.code === 200) {
          this.centerDialogVisible = false;
          this.getDataList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    clickChange(row) {
      this.centerDialogVisible = true;
      this.currentChangeRow = row;
    },
    getDataList() {
      this.tableData = [];
      this.tableLoading = true;
      this.$get(`/UserIsp/Load`, {
        page: this.page,
        limit: this.pageSize,
        key: this.searchText,
        mealType: -1,
        searchUser: this.searchUser,
        country: this.country,
      }).then((res) => {
        this.tableLoading = false;
        if (res.code === 200) {
          res.data = res.data.map((val) => {
            val.isreadonly = true;
            return val;
          });
          this.tableData = res.data;
          this.total = res.count;
        }
      });
      this.dialogUpdateIsp = true;
    },
    changeDataSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.getDataList();
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
    getData() {},
    clickRecharge() {
      if (this.pageWidth < 800) {
        this.showUserInfo = false;
      }
      this.dialogRecharge = true;
    },
    clickEditPassword() {
      if (this.pageWidth < 800) {
        this.showUserInfo = false;
      }
      this.dialogResetPassword = true;
    },
    resetSuccess() {
      this.dialogResetPassword = false;
      this.$post(`/Check/Logout`).then((res) => {
        if (res.code === 200) {
          logout();
        }
      });
    },
    clickSubmit() {
      if (this.hash) {
        this.$get(`/ProxyBuy/ApplyTxid?txid=${this.hash}`).then((res) => {
          if (res.code === 200) {
            this.dialogRecharge = false;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error(this.$t("login.rechargeInput"));
      }
    },
    clickLogout() {
      this.$post(`/Check/Logout`).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t("login.success"));
          logout();
        }
      });
    },
  },
  watch: {
    language() {
      this.getData();
    },
  },
  components: { miyaLang, miyaBtn, resetPassword },
};
</script>
<style scoped lang="stylus">
.miya-user-info
  width 280px
  min-width 280px
  border-left 1px solid rgba(40,30,20,0.2)
  background-color rgba(252, 251, 250, 1)
  padding 0 24px
  .user-header
    display flex
    line-height 72px
    justify-content space-between
    .btnBack
      cursor pointer
      width 20px
      margin 26px 0
      background-image url('../assets/images/icon/home.svg')
      &:hover
        background-image url('../assets/images/icon/home1.svg')
  .user-avatar
    border-radius 50%
    border 6px solid rgba(255, 143, 16, 0.1)
    width 100px
    height 100px
    margin 10vh auto 36px auto
    overflow hidden
    .avatar
      width 100%
  .username
    color $c1
    fontWeight()
    font-size 16px
    text-align center
    margin-bottom 16px
    no-wrap()
  .secret
    color $c2
    font-size $f14
    text-align center
    margin-bottom 16px
    no-wrap()
  .editBtn
    text-align center
    margin-bottom 10px
    
  .adsInfo  
    margin 0 auto
    text-align center
    height 20vh
    img
      width 100%
      height 100%
  .balance-box
    display flex
    margin-bottom 12px
    label
      flex 1
      position relative
      top 5px
    .value-box
      color $c1
      .value
        font-size $f20
        fontWeight()
        margin-right 4px
      .unit
        font-size 12px
  .rechargeBtn
    width 100%
    height 36px
    margin-bottom 20px
    background: linear-gradient(89deg, #FF8F10 0%, #FF7010 100%);
    line-height 36px
    text-align center
    color $c7
    font-size $f16
  .logout
    width 100%
  .cardTip
    color $c10
    font-size $f14
    line-height 18px
    margin-bottom 24px
    text-align center
  .recharge-box
    padding 0 12px
    .titleName
      color $c1
      fontWeight()
      display flex
      .value
        color $c2
    .row
      display flex
      font-size $f14
      line-height 24px
      margin-bottom 16px
      .titleName
        width 140px
      .value
        flex 1
      .qrcode
        padding 10px
        border-radius 2px
        background-color $c5
        .qrimg
          width 168px
        .codeName
          font-size $f12
          text-align center
          line-height 12px
          color $c1
    .hashTitle
      margin-bottom 10px
    .inputTip
      font-size $f12
      color $c2
      margin-top 8px
      line-height 14px
      margin-bottom 54px
    .btn-ok
      width 100%
  .cancelReset
    width 60px
    text-align center
    margin 0 auto
    color $c2
    cursor pointer
    font-size $f16
    letter-spacing 1px
    &:hover
      color $c1
@media screen and (max-width: 1640px)
  .miya-user-info
    width 220px
    min-width 220px
    padding 0 12px
@media screen and (max-width: 800px)
  .miya-user-info
    position absolute
    z-index 10
    top 0
    left 2.6rem
    height 2.6rem
    width calc(100vw - 2.6rem)
    min-width calc(100vw - 2.6rem)
    background-color $c7
    padding 0 0.3rem
    .info-container, .btnBack, .phoneBg
      display none
    .user-header
      position absolute
      top 0.5rem
      left 1rem
      line-height 1.5rem
      >>>.miya-lang
        .lang
          margin-top 0
    .phoneUserBtn
      position absolute
      width calc(100vw - 7rem)
      left 3.5rem
      top 0.4rem
      display flex
      justify-content space-between
      cursor pointer
      .avatar
        width 1.7rem
        height 1.7rem
        border-radius 50%
      .balance-box
        line-height 1.8rem
        display flex
        .value
          font-size 0.6rem
          color $c1
          line-height 1.9rem
        .btn
          color $c8
          font-size 0.7rem
          margin-left 0.3rem
    .recharge-box
      padding 0
      .row
        .titleName
          width 120px
      .inputTip
        margin 0.5rem 0 1rem 0
  .show
    z-index 13
    .phoneBg
      position fixed
      top 0
      left 0
      display block
      width 100vw
      height 100vh
      z-index 10
      background-color rgba(0,0,0,0.5)
      .clickClose
        font-size 0.5rem
        position absolute
        left 0
        width 100%
        bottom 1rem
        color $c4
        cursor pointer
        text-align center
    .info-container
      display block
      position fixed
      top 0
      left 0
      width 100vw
      background-color $c7
      padding 0 2.6rem 2rem 2.6rem
      z-index 18
      .user-avatar
        margin 2rem auto 1rem auto
      .editBtn
        margin-bottom 2rem
</style>
<style lang="stylus">
.miya-user-info
  .miya-resetPassword
    min-height 20px
    .card
      width 100%
      margin 0 12px
    .inputName
      &:first-child
        margin-top 0
    .password-box
      display block
      .item
        &:first-child
          margin-top 20px
        &:last-child
          margin-left 0
    .loginBtn
      line-height 42px
      font-size $f16
  .dialogRecharge
    .el-dialog__header
      padding-bottom 12px
    .el-dialog__body
      padding 0 20px 24px 20px
@media screen and (max-width: 800px)
  .miya-user-info
    .miya-resetPassword
      .card
        width 100%
        margin 0
        min-width 100%
</style>
